module.exports = __webpack_public_path__ + "img/payment_failed.3050286e.png";